import type { Route } from "@react-navigation/native";
import { useNavigation, useRouter } from "expo-router";

interface HistoryObj {
  key?: string;
}

export const useAuthNavigation = () => {
  const navigation = useNavigation();
  const router = useRouter();

  const handleAuthNavigation = () => {
    const state = navigation.getState();
    const routes = state?.routes ?? [];
    const history = (state?.history ?? []) as HistoryObj[];
    const authPaths = ["auth/forgot-password", "auth/new-password", "auth/reset-password", "auth/sign-in", "auth/sign-up"];

    // Filter out auth paths from the navigation history
    const filteredHistory = history.filter((entry) => !authPaths.some((path) => entry.key?.includes(path)));

    // If no non-auth routes exist, default to welcome
    if (!filteredHistory.length) {
      router.replace("/welcome");
      return;
    }

    if (!state) {
      return;
    }

    const foundRouteIndex = routes.findIndex((route: Route<string>) => route.key === filteredHistory[filteredHistory.length - 1]?.key);

    // Update the navigation state with the filtered history
    navigation.reset({
      index: foundRouteIndex,
      history: filteredHistory as unknown[],
      routes: state.routes as any[],
    });
  };

  return handleAuthNavigation;
};
